import { localStorage } from 'dibs-browser-storage';
import {
    MEASUREMENT_STORAGE_KEY,
    MEASUREMENTS,
} from '../finding/SbSharedRefineMenu/sbSharedRefineMenuConstants';
import { ADD_APPLIED_FILTERS } from '../actions/filterActions';
import { SAVE_PREFERENCE } from '../actions/displayPreferenceActions';

const initialState = {
    showMeasurements: false,
};

function displayPreferenceReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ADD_APPLIED_FILTERS: {
            const appliedFilters = payload;
            const hasStoredPreference = !!localStorage.getItem(MEASUREMENT_STORAGE_KEY);

            return {
                ...state,
                showMeasurements:
                    appliedFilters.some(f => f.name === MEASUREMENTS) || hasStoredPreference,
            };
        }
        case SAVE_PREFERENCE:
            if (payload.name === MEASUREMENTS) {
                return {
                    ...state,
                    showMeasurements: !!payload.value,
                };
            } else {
                return state;
            }
        default:
            return state;
    }
}

export default displayPreferenceReducer;
